import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=018e167f&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"
import style0 from "./TextMessage.vue?vue&type=style&index=0&id=018e167f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e167f",
  null
  
)

export default component.exports